import type {
  LoginState,
  UserState,
  TokenState,
  ChatState,
  AppState,
  HomeState,
} from "./types";
import type { ReadItemState } from "./modules/readItemStore";

// 定义 RootStore 的类型
interface RootStore {
  readonly login: LoginState;
  readonly user: UserState;
  readonly token: TokenState;
  readonly chat: ChatState;
  readonly app: AppState;
  readonly home: HomeState;
  readonly readItem: ReadItemState;
}

// 使用 getter 延迟访问,避免循环依赖
export const rootStore: RootStore = {
  get login() {
    return require("./modules/login").LoginStore;
  },
  get user() {
    return require("./modules/user").UserStore;
  },
  get token() {
    return require("./modules/token").TokenStore;
  },
  get chat() {
    return require("./modules/chat").ChatStore;
  },
  get app() {
    return require("./modules/app").AppStore;
  },
  get home() {
    return require("./modules/home").HomeStore;
  },
  get readItem() {
    return require("./modules/readItemStore").readItemStore;
  },
};
